import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import {
  LoginErrorCode,
  LoginErrorCodes,
  LoginErrorRouteSegments,
} from '../../authentication/login-error-codes';

export const authErrorGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  const errorCode = route.queryParamMap.get('errorCode');
  const loginErrorCode = (errorCode as LoginErrorCode) ?? LoginErrorCodes.UNKNOWN;

  const navigateToErrorRoute = (segment: string) => {
    router.navigate(['auth', segment]);
  };

  switch (loginErrorCode) {
    case LoginErrorCodes.USER_NOT_FOUND:
      navigateToErrorRoute(LoginErrorRouteSegments.NOT_FOUND);
      break;
    case LoginErrorCodes.USER_NOT_INVITED:
      navigateToErrorRoute(LoginErrorRouteSegments.NOT_INVITED);
      break;
    default:
      // show login failed page
      return true;
  }

  return false;
};
